<template>
    <div class="scrollbar mt-[48px] md:mt-[64px] overflow-y-auto">
        <main
            class="flex flex-col sm:px-8 sm:pb-8 sm:pt-4 md:px-10 md:pb-10 md:pt-5 xl:px-12 xl:pb-12 xl:pt-7"
        >
            <slot></slot>
        </main>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'TheMain',
})
</script>

<style scoped>
.scrollbar {
    scrollbar-color: #f7f7f7 #e5e5e5;
}
.scrollbar::-webkit-scrollbar {
    width: 1rem;
    height: 1rem;
}
.scrollbar::-webkit-scrollbar-corner {
    background-color: transparent;
}
.scrollbar::-webkit-scrollbar-thumb {
    background-color: #cbd0d7;
    min-height: 10rem;
}
.scrollbar::-webkit-scrollbar-thumb,
.scrollbar::-webkit-scrollbar-track {
    border: 0.25rem solid transparent;
    background-clip: padding-box;
    border-radius: 0.5rem;
}
.scrollbar::-webkit-scrollbar-track {
    background-color: transparent;
}
.dark .scrollbar {
    scrollbar-color: #1d1d1d #161616;
}
.dark .scrollbar::-webkit-scrollbar-thumb {
    background-color: #111;
    min-height: 10rem;
}
</style>
